import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  subscriptionStatus: any;

  constructor(private authService: AuthService) {
    this.subscriptionStatus = this.authService.getSubscriptionStatus();
  }

  ngOnInit() {
  }

}
